export const CREATE_PERFECT_STORE_TITLE = 'Create Perfect Store';

export const PERFECT_STORE_TARGET_TYPES = {
  FirstPositionTarget: 'First Position Target',
  RacksAndCoolersTarget: 'Racks and Coolers Target',
  StoreExecutionTarget: 'Store Execution Target',
  MustHaveProductsTarget: 'Must Have Products',
  StoreExecutionTargetPepIris: 'Store Execution Target - PepIris'
};

export const PERFECT_STORE_TARGET_TYPE_VALUES = {
  FIRST_POSITION: 'First Position Target',
  RACKS_AND_COOLERS: 'Racks and Coolers Target',
  STORE_EXECUTION: 'Store Execution Target',
  MUST_HAVE_PRODUCTS: 'Must Have Products',
  STORE_EXECUTION_PEPIRIS: 'Store Execution Target - PepIris'
};

// Legacy API/code values kept for mid-migration compatibility (in-memory / older payloads).
export const LEGACY_PERFECT_STORE_TARGET_TYPE_VALUES = {
  FIRST_POSITION: 'FIRST_POSITION',
  RACKS_AND_COOLERS: 'RACKS_AND_COOLERS',
  STORE_EXECUTION: 'STORE_EXECUTION',
  MUST_HAVE_PRODUCTS: 'MUST_HAVE_PRODUCTS',
  STORE_EXECUTION_PEPIRIS: 'STORE_EXECUTION_PEPIRIS'
};

export const PERFECT_STORE_TARGET_TYPE_OPTIONS = [
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION,
    displayText: PERFECT_STORE_TARGET_TYPES.FirstPositionTarget,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION
  },
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.RACKS_AND_COOLERS,
    displayText: PERFECT_STORE_TARGET_TYPES.RacksAndCoolersTarget,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.RACKS_AND_COOLERS
  },
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION,
    displayText: PERFECT_STORE_TARGET_TYPES.StoreExecutionTarget,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION
  },
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.MUST_HAVE_PRODUCTS,
    displayText: PERFECT_STORE_TARGET_TYPES.MustHaveProductsTarget,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.MUST_HAVE_PRODUCTS
  },
  {
    id: PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION_PEPIRIS,
    displayText: PERFECT_STORE_TARGET_TYPES.StoreExecutionTargetPepIris,
    value: PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION_PEPIRIS
  }
];

export const isFirstPositionTarget = (targetType) =>
  targetType === PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION ||
  targetType === LEGACY_PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION;

export const isStoreExecutionPepIrisTarget = (targetType) =>
  targetType === PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION_PEPIRIS ||
  targetType ===
    LEGACY_PERFECT_STORE_TARGET_TYPE_VALUES.STORE_EXECUTION_PEPIRIS;

export const PEPIRIS_TASK_NAMES = {
  COOLER_PURITY: 'Cooler Purity',
  OUT_OF_STOCK_CE: 'Out-of-Stock Products for CE',
  OUT_OF_STOCK_CEDO_DO: 'Out-of-Stock Products for CEDO/DO'
};

export const PEPIRIS_TASK_NAME_OPTIONS = [
  {
    id: PEPIRIS_TASK_NAMES.COOLER_PURITY,
    displayText: PEPIRIS_TASK_NAMES.COOLER_PURITY,
    value: PEPIRIS_TASK_NAMES.COOLER_PURITY
  },
  {
    id: PEPIRIS_TASK_NAMES.OUT_OF_STOCK_CE,
    displayText: PEPIRIS_TASK_NAMES.OUT_OF_STOCK_CE,
    value: PEPIRIS_TASK_NAMES.OUT_OF_STOCK_CE
  },
  {
    id: PEPIRIS_TASK_NAMES.OUT_OF_STOCK_CEDO_DO,
    displayText: PEPIRIS_TASK_NAMES.OUT_OF_STOCK_CEDO_DO,
    value: PEPIRIS_TASK_NAMES.OUT_OF_STOCK_CEDO_DO
  }
];

export const PEPIRIS_CSV_RULES = {
  type: 'text/csv',
  size: 10 * 1024 * 1024,
  enforceSize: true,
  columns: [
    {
      name: 'Store Id',
      required: true,
      type: 'alphanumeric',
      minChar: 1,
      maxChar: 255
    }
  ],
  requiredHeaders: ['Store Id']
};

export const FIRST_POSITION_CSV_RULES = {
  type: 'text/csv',
  size: 10 * 1024 * 1024,
  enforceSize: true,
  columns: [
    {
      name: 'Store Id',
      required: true,
      type: 'alphanumeric',
      minChar: 1,
      maxChar: 255
    },
    {
      name: 'Visit Number',
      required: true,
      type: 'number'
    },
    {
      name: 'Points',
      required: true,
      type: 'number'
    }
  ],
  requiredHeaders: ['Store Id', 'Visit Number', 'Points']
};

// Target types the Display step currently supports; add more here to enable it for other types.
export const PERFECT_STORE_DISPLAY_STEP_TARGET_TYPES = [
  PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION
];

export const isDisplayStepApplicable = (targetType) =>
  PERFECT_STORE_DISPLAY_STEP_TARGET_TYPES.includes(targetType) ||
  targetType === LEGACY_PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION;

export const PERFECT_STORE_IMAGE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp'
];

export const PERFECT_STORE_IMAGE_DIMENSIONS = {width: 800, height: 267};

// Ratio derived from the required 800x267 dimensions (3:1)
export const PERFECT_STORE_IMAGE_ASPECT_RATIO =
  PERFECT_STORE_IMAGE_DIMENSIONS.width / PERFECT_STORE_IMAGE_DIMENSIONS.height;

export const PERFECT_STORE_IMAGE_ASPECT_RATIO_LABEL = '3:1';

export const PERFECT_STORE_IMAGE_MAX_SIZE_BYTES = 70 * 1024;

export const PEPIRIS_IMAGE_TYPES = ['image/webp'];

export const PEPIRIS_IMAGE_MAX_SIZE_BYTES = 70 * 1024;

export const PEPIRIS_BANNER_IMAGE_DIMENSIONS = {width: 400, height: 170};

export const PEPIRIS_THUMBNAIL_IMAGE_DIMENSIONS = {width: 72, height: 218};

export const PEPIRIS_GUIDELINE_IMAGE_DIMENSIONS = {width: 250, height: 420};

export const MIN_PEPIRIS_GUIDELINES = 2;

export const MAX_PEPIRIS_GUIDELINES = 5;

export const PEPIRIS_GUIDELINE_MAX_LENGTH = 200;

export const MAX_RACK_DISPLAYS = 3;

export const RACK_TEXT_MAX_LENGTH = 100;

export const BANNER_TITLE_MAX_LENGTH = 100;

export const BANNER_DESCRIPTION_MAX_LENGTH = 500;

export const VISIT_STATUS_CSV_RULES = {
  type: 'text/csv',
  size: 10 * 1024 * 1024,
  enforceSize: true,
  columns: [
    {
      name: 'Store Id',
      required: true,
      type: 'alphanumeric',
      minChar: 1,
      maxChar: 255
    },
    {
      name: 'Visit Number',
      required: true,
      type: 'number'
    },
    {
      name: 'Status',
      required: false,
      type: 'string'
    }
  ],
  requiredHeaders: ['Store Id', 'Visit Number', 'Status']
};

export const MOCK_PERFECT_STORE_LIST = [
  {
    id: 'ps-1',
    name: 'First Position Q1 Target',
    targetType: PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION,
    status: 'Draft'
  }
];

/** Sample GET /perfect-store-targets/{id} payload for Preview local/demo fallback. */
export const MOCK_PERFECT_STORE_DETAIL = {
  id: 11,
  applicationId: 1,
  targetType: LEGACY_PERFECT_STORE_TARGET_TYPE_VALUES.FIRST_POSITION,
  name: 'Demo_First_Position_2026-8',
  storeTargetFileUrl:
    'https://dpsb2bproductsdeveus01sa.blob.core.windows.net/input/inbound/perfect_store/mexico/test-enrollment_8c98e3e3-0c86-4508-988d-9a319974da53.csv',
  storeTargetFileName:
    'test-enrollment_8c98e3e3-0c86-4508-988d-9a319974da53.csv',
  activeStartDate: '2026-09-01T00:00:00Z',
  activeEndDate: '2026-09-30T23:59:59Z',
  displaySameAsActive: true,
  displayStartDate: '2026-09-01T00:00:00Z',
  displayEndDate: '2026-09-30T23:59:59Z',
  awardPointsImmediately: true,
  pointDeliveryDate: '2026-10-01T00:00:00Z',
  requiredUserToJoin: true,
  displayContent: {
    banner: {
      imageUrl: 'https://blob.azure.com/banners/gt-q3.png',
      filename: 'gt-q3.png',
      translations: {
        en: {
          title: 'Correctly position product stands',
          description: 'Your sales rep will visit 4 times'
        },
        es: {
          title: 'Coloque los estantes correctamente',
          description: 'Su representante de ventas visitará 4 veces'
        }
      }
    },
    racks: [
      {
        index: 1,
        imageUrl: 'https://blob.azure.com/racks/rack1.png',
        filename: 'rack1.png',
        translations: {
          en: {
            header: 'Place display close to hot area',
            subHeader: 'Near checkout or entrance'
          }
        }
      },
      {
        index: 2,
        imageUrl: 'https://blob.azure.com/racks/rack2.png',
        filename: 'rack2.png',
        translations: {
          en: {
            header: 'Keep shelves fully stocked',
            subHeader: 'Minimum 5 units per shelf'
          }
        }
      },
      {
        index: 3,
        imageUrl: 'https://blob.azure.com/racks/rack3.png',
        filename: 'rack3.png',
        translations: {
          en: {
            header: 'Place price tags clearly',
            subHeader: 'Visible from 1 meter'
          }
        }
      }
    ]
  },
  status: 'In-progress',
  updatedBy: null,
  updatedAt: '2026-09-11T07:15:58.937808Z',
  createdBy: null,
  createdAt: '2026-09-08T10:29:09.043762Z'
};
